export default class MaxValidator {

    getErrorMessage(prop) {
        return "Field should be less than or equal to " + prop;
    }

    validate(value, prop) {
        if (value === null || value === undefined) {
            return true;
        }
        if (prop === null || prop === undefined) {
            return true;
        }
        return value <= prop;
    }

}
